import ServiceCategoryPage from "../components/ServiceCategoryPage";
import electricianService from "../data/services/electricianService";

function Electrician() {
  return <ServiceCategoryPage service={electricianService} />;
}

export default Electrician;